/* eslint-disable import/prefer-default-export */
export enum Breakpoints {
    xs = 'xs',
    sm = 'sm',
    md = 'md',
    lg = 'lg',
    xl = 'xl',
}
